// Get Vue reference for instantiating
import Vue from 'vue';

// Main App component
Vue.component('App', require('./views/App.vue').default);

// Register layout
Vue.component('Layout', require('./layouts/Layout.vue').default);

// Register components for layout
Vue.component('AppHeader', require('./components/Header.vue').default);
Vue.component('AppFooter', require('./components/Footer.vue').default);
Vue.component('Banner', require('./components/Banner.vue').default);
Vue.component('Pagination', require('laravel-vue-pagination/src/LaravelVuePagination.vue').default);
Vue.component('Search', require('./components/Search.vue').default);
Vue.component('Categories', require('./components/Categories.vue').default);
Vue.component('Resources', require('./components/ResourceWeek.vue').default);
Vue.component('Tags', require('./components/Tags.vue').default);
Vue.component('Notifications', require('./components/Notifications.vue').default);
Vue.component('Payment', require('./components/Payment.vue').default);
Vue.component('ScoreBadge', require('./components/ScoreBadge.vue').default);
Vue.component('ScorecardEatingGroup', require('./components/ScorecardEatingGroup.vue').default);
Vue.component('DialGauge', require('./components/gauges/DialGauge.vue').default);
Vue.component('LinearGauge', require('./components/gauges/LinearGauge.vue').default);
Vue.component('LoadingModal', require('./components/LoadingModal.vue').default);
Vue.component('LoadingSpinner', require('./components/LoadingSpinner.vue').default);
Vue.component('FoodSearchbox', require('./components/FoodSearchbox.vue').default);
Vue.component('FoodSearchList', require('./components/FoodSearchList.vue').default);
Vue.component('FoodNavbar', require('./components/FoodNavbar.vue').default);
Vue.component('ContactUsBlurb', require('./components/ContactUsBlurb.vue').default);
Vue.component('AddMealModal', require('./components/AddMealModal.vue').default);
Vue.component('DateModal', require('./components/DateModal.vue').default);
Vue.component('FactorScale', require('./components/FactorScale.vue').default);
Vue.component('GoalScale', require('./components/GoalScale.vue').default);
Vue.component('SharePortalNotification', require('./components/SharePortalNotification.vue').default);
Vue.component('Pagination', require('./components/Pagination.vue').default);
Vue.component('TipsModal', require('./components/TipsModal.vue').default);
Vue.component('UpgradeModal', require('./components/UpgradeModal.vue').default);
Vue.component('DisclaimerFoodSearch', require('./components/DisclaimerFoodSearch.vue').default);
Vue.component('AutoFitText', require('./components/AutoFitText.vue').default);
